<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item  label="分类Id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!-- <a-input    :disabled="true" :trigger-change="true" ></a-input> -->
          <a-tree-select
            v-decorator="['classId', validatorRules.classId]"
            :treeData="classIdTreeData"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择分类"
            tree-default-expand-all
            @change="handleClassIdChange"
          ></a-tree-select>
        </a-form-item>
        <a-form-item v-show="false" label="分类名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input   v-decorator="['className', validatorRules.className]" :disabled="true" :trigger-change="true" ></a-input>
        </a-form-item>
        <a-form-item label="文件编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input   v-decorator="['fileCode', validatorRules.fileCode]"  :trigger-change="true" ></a-input>
        </a-form-item>
        <a-form-item label="文件来源" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['fileSource', validatorRules.fileSource]" :trigger-change="true" dictCode="bus_common_file_source" placeholder="请选择文件来源"/>
        </a-form-item>
        <a-form-item label="文件类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['fileType', validatorRules.fileType]" :trigger-change="true" dictCode="bus_common_file_type" placeholder="请选择文件类型"/>
        </a-form-item>
        <a-form-item label="文件路径" :labelCol="labelCol" :wrapperCol="wrapperCol" extra="只允许上传PDF文件，请勿传其他文件！" >
          <j-upload accept=".pdf"  ref="jUploadRef" :beforeUpload="handleBeforeUpload" @fileInfo="handleGetFileInfo" :returnUrl="true" v-decorator="['fileUrl', validatorRules.fileUrl]"     :uploadAction="url.upload"  ></j-upload>
        </a-form-item>
        <a-form-item v-show="false" label="必须参数1" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input   v-decorator="['fileExtension']" :disabled="true" :trigger-change="true" ></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="必须参数2" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input   v-decorator="['filePath']" :disabled="true" :trigger-change="true" ></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="必须参数3" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input   v-decorator="['fileSize']" :disabled="true" :trigger-change="true" ></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="必须参数4" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input   v-decorator="['newFileName']" :disabled="true" :trigger-change="true" ></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="必须参数5" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input   v-decorator="['originalFileName']" :disabled="true" :trigger-change="true" ></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JUpload from '../components/JUpload'
  // import JUpload from '@/components/common/JUpload.vue'


  export default {
    name: "CommonFileManageModal",
    components: { 
      JDictSelectTag,JUpload
    },
    props:{
      classIdTreeData:{
        type:Array,
        default:[]
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          classId: {rules: [{
            required: true, message: '请退出选择文件分类!',
          }]},
          className: {rules: [{
          }]},
          fileCode: {rules: [{
              required: true, message: '请输入文件编码!',
          }]},
          fileSource: {rules: [{
              required: true, message: '请选择文件来源!',
          }]},
          fileType: {rules: [{
              required: true, message: '请选择文件类型!',
          }]},
          fileUrl: {rules: [{
              required: true, message: '请上传一个文件,只能是pdf格式的!',
          }]},
        },
        url: {
          add: "/factory/base/commonFileManage/add",
          edit: "/factory/base/commonFileManage/edit",
          upload:window._CONFIG['domianURL']+"/factory/base/commonFileManage/uploadFile"
        },
        isAdd:false,
        fileUrlList:[]
      }
    },
    created () {
    },
    methods: {
      handleBeforeUpload(file){
        console.log(file.type)
        if (file.type !== 'application/pdf') {
          this.$message.error("'请上传PDF格式'")
          return false;
        }
        return true;
      },
      handleClassIdChange(value,label){
        this.form.setFieldsValue({
          className:label[0]
        })
      },
      add (record) {
        console.log(record)
        this.edit(record);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          if(record.id){
            this.isAdd=false
          }else{
            this.isAdd=true
          }
          this.$refs.jUploadRef.initFileListArr()
          this.form.setFieldsValue(pick(this.model,'classId','className','fileSource','fileType','fileUrl','fileCode'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            let formData = Object.assign(this.model, values);
            if(!this.model.id){
              httpurl+=this.url.add;
              formData.fileUrlList=this.fileUrlList
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              formData.fileUrlList=this.fileUrlList
              method = 'post';
            }
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              // that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      handleGetFileInfo(row){
        this.fileUrlList=[]
        this.fileUrlList.push(row)
      },
    }
  }
</script>